import { render, staticRenderFns } from "./PricingPlans.vue?vue&type=template&id=609e5261&"
import script from "./PricingPlans.vue?vue&type=script&lang=js&"
export * from "./PricingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports